export default "__VITE_ASSET__DakK9Qto__"